import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <AnimatePresence data-id="element-388">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-stone-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" aria-hidden="true" data-id="element-389" />

          {/* Modal Card */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.5
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-390">
            <div className="bg-[#F7F3EF] w-full max-w-2xl max-h-[85vh] rounded-2xl shadow-2xl border border-[#E8CFCF]/40 flex flex-col pointer-events-auto overflow-hidden" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-391">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#E8CFCF]/40 bg-white/50" data-id="element-392">
                <h2 id="modal-title" className="text-2xl font-bold text-[#3A3A3A]" data-id="element-393">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-[#F5EAEA] text-[#3A3A3A]/50 hover:text-[#D88C7A] transition-colors" aria-label="Cerrar" data-id="element-394">
                  <X className="w-6 h-6" data-id="element-395" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto custom-scrollbar text-[#3A3A3A]/80 leading-relaxed space-y-4" data-id="element-396">
                {children}
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}